/* app/js/src/components/common/tagsWrapper/tagsWrapper.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
/*# sourceMappingURL=tagsWrapper.component.css.map */
